/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.16"
        height="94.33"
        viewBox="0 0 85.16 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M18.52 22.83a1.25 1.25 0 0 1 .12 2.49H11.4A8.9 8.9 0 0 0 2.5 34v24.25a1.38 1.38 0 0 0 1.26 1.38h5.36a1.25 1.25 0 0 1 .13 2.49H3.89A3.89 3.89 0 0 1 0 58.45V34.22a11.41 11.41 0 0 1 11.11-11.39h7.41ZM29.17 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M35.78 49.7A1.26 1.26 0 0 1 37 50.82v7.63a3.89 3.89 0 0 1-3.69 3.68h-4.14v20.79a1.26 1.26 0 0 1-1.12 1.25h-.13a1.24 1.24 0 0 1-1.24-1.12V60.89a1.26 1.26 0 0 1 1.12-1.25h5.35a1.4 1.4 0 0 0 1.39-1.26V51a1.25 1.25 0 0 1 1.13-1.24ZM25.63 22.83A11.4 11.4 0 0 1 37 33.93v1.91a1.25 1.25 0 0 1-2.49.12v-1.74a8.9 8.9 0 0 0-8.63-8.89h-7.36a1.252 1.252 0 0 1-.13-2.5h7.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 82.94v11.39"/>
        <path
          fill="#0e497b"
          d="M19.77 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 60.83v22.11"/>
        <path
          fill="#0e497b"
          d="M18.52 59.58a1.25 1.25 0 0 1 1.24 1.12v22.23a1.24 1.24 0 0 1-1.25 1.25 1.26 1.26 0 0 1-1.25-1.12V60.83a1.25 1.25 0 0 1 1.26-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 82.94v11.39"/>
        <path
          fill="#0e497b"
          d="M10.37 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 39.5v43.44"/>
        <path
          fill="#0e497b"
          d="M9.12 38.25a1.26 1.26 0 0 1 1.25 1.12v43.57a1.25 1.25 0 0 1-2.49.12V39.5a1.25 1.25 0 0 1 1.24-1.25ZM18.52 0a9.83 9.83 0 1 0 9.83 9.83A9.83 9.83 0 0 0 18.52 0Zm0 2.5a7.33 7.33 0 1 1-7.32 7.33 7.33 7.33 0 0 1 7.32-7.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M22.9 35.46a1.25 1.25 0 0 1 1.89 1.62l-.09.1-6.07 6.35 5.94 6.22a1.24 1.24 0 0 1 .06 1.66l-.1.1a1.24 1.24 0 0 1-1.66.06l-.1-.1L16 44.4a1.25 1.25 0 0 1-.09-1.62l.09-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M73.75 22.83a11.4 11.4 0 0 1 11.4 11.1v24.52a3.89 3.89 0 0 1-3.69 3.68H76a1.25 1.25 0 0 1-.12-2.49h5.35a1.39 1.39 0 0 0 1.39-1.26V34.47a.32.32 0 0 1 0-.16v-.09h-.09A8.9 8.9 0 0 0 74 25.33h-7.38a1.252 1.252 0 0 1-.13-2.5h7.24ZM58.49 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M49.37 49.7a1.24 1.24 0 0 1 1.24 1.12v7.43a1.39 1.39 0 0 0 1.26 1.38h5.36a1.25 1.25 0 0 1 1.24 1.12v22.17a1.24 1.24 0 0 1-1.25 1.25A1.26 1.26 0 0 1 56 83.06V62.14h-4a3.89 3.89 0 0 1-3.88-3.69V51a1.25 1.25 0 0 1 1.25-1.3ZM66.64 22.83a1.25 1.25 0 0 1 .13 2.49h-7.25A8.88 8.88 0 0 0 50.63 34v1.88a1.25 1.25 0 0 1-2.49.12v-1.78a11.41 11.41 0 0 1 11.09-11.39h7.41Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 82.94v11.39"/>
        <path
          fill="#0e497b"
          d="M67.89 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 60.83v22.11"/>
        <path
          fill="#0e497b"
          d="M66.64 59.58a1.25 1.25 0 0 1 1.24 1.12v22.23a1.24 1.24 0 0 1-1.25 1.25 1.26 1.26 0 0 1-1.25-1.12V60.83a1.25 1.25 0 0 1 1.26-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 82.94v11.39"/><path
          fill="#0e497b"
          d="M77.28 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 39.5v43.44"/><path
          fill="#0e497b"
          d="M76 38.25a1.26 1.26 0 0 1 1.25 1.12v43.57a1.25 1.25 0 0 1-2.49.12V39.5A1.25 1.25 0 0 1 76 38.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M66.63 0a9.83 9.83 0 1 0 9.83 9.83A9.83 9.83 0 0 0 66.63 0Zm0 2.5a7.33 7.33 0 1 1-7.32 7.33 7.33 7.33 0 0 1 7.32-7.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M65.18 42.28a1.252 1.252 0 0 1 .13 2.5H18.47a1.25 1.25 0 0 1-.13-2.49h46.84Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M60.49 35.42a1.25 1.25 0 0 1 1.67-.06l.1.1 6.9 7.21a1.25 1.25 0 0 1 .09 1.62l-.09.11-6.77 7.07a1.25 1.25 0 0 1-1.9-1.62l.09-.1 5.94-6.22-6.07-6.35a1.24 1.24 0 0 1 0-1.66Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleTwoWayArrowsIcon';

export default Icon;
